import React, { useContext } from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// react-bootstrap components
import {
  Badge,
  Button,
  ButtonGroup,
  Card,
  Dropdown,
  Form,
  InputGroup,
  Navbar,
  Nav,
  Pagination,
  Container,
  Row,
  Col,
  Collapse,
} from "react-bootstrap";
import CustomBreadcrumb from "components/Custom/CustomBreadcrumb.js";
import { getUserBadges } from "graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";
import { AuthContext } from "contexts/authContext";
import { useTheme } from "contexts/ThemeContext";

function AdminNavbar({ signOut, routes }) {
  // Contexts
  const currentUser = useContext(AuthContext);
  const { isDark, toggleTheme } = useTheme();
  const email = currentUser.emailId;
  const name = currentUser.firstName;
  const userClientId = currentUser.clientId;

  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [unviewedReportsCount, setUnviewedReportsCount] = useState(0);
  const [notificationsCount, setNotificationsCount] = useState(0);

  const fetchUnviewedReports = async () => {
    try {
      const response = await API.graphql(graphqlOperation(getUserBadges, {requester_client_id: userClientId}));
      if (response.data?.getUserBadges?.success) {
        const count = response.data.getUserBadges.body.unviewed_reports_count;
        setUnviewedReportsCount(count);
        setNotificationsCount(notificationsCount + count);
      } else {
        console.error(response.data?.getUserBadges?.message);
      }
      return response.data?.getUserBadges?.success;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  useEffect(() => {
    // Initial check
    fetchUnviewedReports();
    // Set up polling every 1 minutes (60000 milliseconds)
    const interval = setInterval(() => {
      fetchUnviewedReports();
    }, 60000);

    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Navbar expand="lg">
        <Container fluid>
          <div className="navbar-wrapper">
            <div className="navbar-minimize">
              <Button
                className="btn-fill btn-round btn-icon d-none d-lg-block bg-dark border-dark"
                variant="dark"
                onClick={() => document.body.classList.toggle("sidebar-mini")}
              >
                <i className="fas fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i className="fas fa-bars visible-on-sidebar-mini"></i>
              </Button>
              <Button
                className="btn-fill btn-round btn-icon d-block d-lg-none bg-dark border-dark"
                variant="dark"
                onClick={() =>
                  document.documentElement.classList.toggle("nav-open")
                }
              >
                <i className="fas fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i className="fas fa-bars visible-on-sidebar-mini"></i>
              </Button>
            </div>
            {/* <Navbar.Brand href="#pablo" onClick={(e) => e.preventDefault()}>
              Buttons
            </Navbar.Brand> */}
          </div>
          <CustomBreadcrumb routes={routes} />
          <button
            className="navbar-toggler navbar-toggler-right border-0"
            type="button"
            onClick={() => setCollapseOpen(!collapseOpen)}
          >
            <span className="navbar-toggler-bar burger-lines"></span>
            <span className="navbar-toggler-bar burger-lines"></span>
            <span className="navbar-toggler-bar burger-lines"></span>
          </button>
          <Navbar.Collapse className="justify-content-end" in={collapseOpen}>
            {/* <Nav className="nav mr-auto" navbar>
              <Form
                className="navbar-form navbar-left navbar-search-form ml-3 ml-lg-0"
                role="search"
              >
                <InputGroup>
                  <i className="nc-icon nc-zoom-split"></i>
                  <Form.Control
                    defaultValue=""
                    placeholder="Search..."
                    type="text"
                  ></Form.Control>
                </InputGroup>
              </Form>
            </Nav> */}
            <Nav navbar>
              <Nav.Item className="d-flex align-items-center mr-2">
                <button
                  type="button"
                  className="theme-toggle"
                  onClick={toggleTheme}
                  aria-pressed={isDark}
                  aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
                  title={isDark ? "Switch to light mode" : "Switch to dark mode"}
                >
                  <i
                    className={isDark ? "fas fa-sun theme-toggle__icon" : "fas fa-moon theme-toggle__icon"}
                    aria-hidden="true"
                  ></i>
                  <span className="theme-toggle__label">
                    {isDark ? "Light" : "Dark"}
                  </span>
                </button>
              </Nav.Item>
              {/* <Dropdown as={Nav.Item}>
                <Dropdown.Toggle
                  as={Nav.Link}
                  id="dropdown-165516306"
                  variant="default"
                >
                  <i className="nc-icon nc-planet"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Create New Post
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Manage Something
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Do Nothing
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Submit to live
                  </Dropdown.Item>
                  <li className="divider"></li>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Another action
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown as={Nav.Item}>
                <Dropdown.Toggle
                  as={Nav.Link}
                  id="dropdown-414718872"
                  variant="default"
                >
                  <i className="nc-icon nc-bell-55 mr-1"></i>
                  <span className="notification">5</span>
                  <span className="d-lg-none">Notification</span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Notification 1
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Notification 2
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Notification 3
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Notification 4
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Notification 5
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
              <Dropdown as={Nav.Item}>
                <Dropdown.Toggle
                  as={Nav.Link}
                  id="dropdown-user-actions"
                  variant="primary"
                >
                  <i
                    className="nc-icon nc-circle-09"
                    style={{ fontSize: "2em", marginRight: "10px" }}
                  ></i>
                  {notificationsCount !== 0 && (
                    <span className="notification">{notificationsCount}</span>
                  )}
                  <div className="user">
                    {/* <div className="photo">
                      <img alt="..." src={require("assets/img/blank_face.jpg")} />
                    </div> */}
                    <div className="primary" id="user-info">
                      {name || email}
                    </div>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  alignRight
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  {/* <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="nc-icon nc-email-85"></i>
                    Messages
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="nc-icon nc-umbrella-13"></i>
                    Help Center
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="nc-icon nc-settings-90"></i>
                    Settings
                  </Dropdown.Item>
                  <div className="divider"></div>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="nc-icon nc-lock-circle-open"></i>
                    Lock Screen
                  </Dropdown.Item> */}
                  <Dropdown.Item>
                    <Link
                      to={{
                        pathname: `/admin/reports`,
                      }}
                    >
                      <i className="nc-icon nc-single-copy-04"></i>
                      <span className="notification">
                        {unviewedReportsCount}
                      </span>
                      My Reports
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={(e) => e.preventDefault()}>
                    <Link
                      to={{
                        pathname: `/admin/user-profile`,
                      }}
                    >
                      <i className="nc-icon nc-badge"></i>
                      User Profile
                    </Link>
                  </Dropdown.Item>
                  <Dropdown.Item className="text-danger" onClick={signOut}>
                    <i className="nc-icon nc-button-power"></i>
                    Log out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default AdminNavbar;
